exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#page-intro{margin-bottom:50vh}#page-intro .animation-area__center{height:70px}.page-intro__animated-item{position:absolute}#page-intro__text-1{opacity:0}#page-intro__text-2{opacity:0;margin-top:60px}#page-intro__fuel{height:120px;left:calc(-50vw - 100px)}#page-intro__plus{height:70px;top:25px;left:-35px;transform:scale(0)}#page-intro__plug{height:120px;right:calc(-50vw - 100px)}#page-intro__next-btn{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d4a0a36","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-intro.vue
// module id = 62
// module chunks = 0